import React from "react";
import { StarIcon } from "lucide-react";
interface Review {
  name: string;
  location: string;
  text: string;
}
const REVIEWS: Review[] = [{
  name: "Graciela P.",
  location: "Rosario, Santa Fe",
  text: "Tenía todo desordenado y no sabía por dónde arrancar. Con los tomos armé el árbol y entendí qué partidas pedir primero. Me ahorró meses de vueltas."
}, {
  name: "Ernesto D.",
  location: "Córdoba Capital",
  text: "Lo que más me sirvió fue lo de la naturalización y las fechas. Iba a gastar en apostillas al pedo. Muy claro y directo, sin vueltas."
}, {
  name: "Marta R.",
  location: "La Plata, Buenos Aires",
  text: "Los modelos de correo al comune son oro. Escribí y me contestaron. El Excel para organizar todo me cambió la cabeza. Súper recomendable."
}, {
  name: "Hugo S.",
  location: "Mendoza",
  text: "Explica todo con la reforma nueva de 2025, que era lo que más me confundía. Vale muchísimo más de lo que cuesta."
}];
export function Reviews() {
  return <section className="w-full bg-cream px-5 py-10" data-id="element-148" data-mp="2re8jt44gg5ko">
      <div className="mx-auto max-w-md" data-id="element-149" data-mp="2md1dl9hyneg4">
        <h2 className="text-center font-serif text-2xl font-bold text-deep-green" data-id="element-150" data-mp="2mbzqg6no71i1">
          Lo que dicen quienes ya lo usan
        </h2>

        <div className="mt-6 space-y-4" data-id="element-151" data-mp="2dcw6l0goii2h">
          {REVIEWS.map(r => <figure key={r.name} className="rounded-2xl border border-sand bg-beige p-4" data-id="element-152" data-mp="2dez5k9zt7ljc">
              <div className="flex items-center gap-1 text-gold" data-id="element-153" data-mp="354c25k07rf4u">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold" aria-hidden="true" data-id="element-154" data-mp="30cai3bwt0k49" data-mpi={i} />)}
              </div>
              <blockquote className="mt-2 text-sm leading-relaxed text-ink/85" data-id="element-155" data-mp="3suogpdpysa4e">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-2 text-xs font-semibold text-italian-green" data-id="element-156" data-mp="3o0tplp814sva">
                {r.name} · <span className="text-ink/60" data-id="element-157" data-mp="1m65ya1cr7z11">{r.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}